import { combineReducers } from 'redux';

import cart from './cart_reducer';
import form_errors from './form_errors_reducer';
import loading from './loading_reducer';
import product_quantity from './product_quantity_reducer';

export default combineReducers( {
	                                cart, form_errors, loading, product_quantity
                                } );